import { DeviceSecurityDetect } from '@capacitor-community/device-security-detect';
import { Injectable } from '@angular/core';
import { logger } from 'src/app/common/services/logging/logging.service';
import { PlatformService } from './platform.service';
import { AsyncSubject, combineLatest } from 'rxjs';
import { MEErrorService } from 'src/app/common/error/me-error.service';
import { App } from '@capacitor/app';
import { Device } from '@capacitor/device';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class DeviceSecurityService {

    constructor(
        private srvError: MEErrorService,
    ) { }

    public isDeviceSecure(): AsyncSubject<boolean> {
        let ret = new AsyncSubject<boolean>();

        // if (PlatformService.isBrowser() || !environment.production) {
        if (PlatformService.isBrowser()) {
            ret.next(true);
            ret.complete();
        } else {
            combineLatest([
                DeviceSecurityDetect.isJailBreakOrRooted(),
                Device.getInfo()
            ]).subscribe(([isJailbreakOrRooted, deviceInfo]) => {
                logger.debug('Is JailBreak : ', isJailbreakOrRooted.value);
                logger.debug('Is Virtual   : ', deviceInfo.isVirtual);
                let isDeviceSecure = !isJailbreakOrRooted.value && !deviceInfo.isVirtual;
                if (!isDeviceSecure) {
                    this.showErrorDialog();
                }
                ret.next(isDeviceSecure);
                ret.complete();
            });
        }

        return ret;
    }

    /**
     * Show the dialog to inform the user about the security issue.
     */
    private showErrorDialog() {
        let title: string = SecurityAlert.title;
        let message: string = SecurityAlert.message;
        let buttonText: string = SecurityAlert.buttonText;
        this.srvError.showErrorDialog(title, message, buttonText).subscribe(() => {
            if (PlatformService.isAndroid()) {
                App.exitApp();
            }
            else {
                this.srvError.systemAvailable.next(false);
                this.srvError.systemUnAvailableError.next({ title, message });
            }
        });
    }

}

// Can only show English since the language is not defined yet
export class SecurityAlert {
    public static readonly title: string = "Security Alert";
    public static readonly message: string = "Your device has been detected as rooted or emulated, which poses a security risk. For your safety, this application cannot run on rooted or emulated devices. The app will now close. If you believe this is in error, please contact support for assistance.";
    public static readonly buttonText: string = "Close";
}